var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIcHelp = function SvgIcHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.493 3.507c-4.676-4.676-12.31-4.676-16.986 0s-4.676 12.31 0 16.986 12.31 4.676 16.986 0 4.676-12.31 0-16.986Zm1.719 11.88-3.842-1.29a6.699 6.699 0 0 0 0-4.22l3.842-1.29c.707 2.225.707 4.601 0 6.8ZM1.788 8.613l3.842 1.29a6.698 6.698 0 0 0 0 4.22l-3.842 1.29a11.152 11.152 0 0 1 0-6.8Zm6.37 7.229a5.462 5.462 0 0 1 0-7.71 5.462 5.462 0 0 1 7.71 0 5.462 5.462 0 0 1 0 7.71c-2.15 2.123-5.587 2.123-7.71 0Zm7.23-14.054-1.29 3.842a6.698 6.698 0 0 0-4.221 0l-1.29-3.842c2.225-.707 4.601-.707 6.8 0ZM8.612 22.212l1.29-3.842a6.699 6.699 0 0 0 4.22 0l1.29 3.842c-2.225.707-4.601.707-6.8 0Z",
    fill: "url(#ic-help_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-help_svg__a",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9C142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66C9CB"
  })))));
};

export default SvgIcHelp;